export const MOCK_API_VERSIONS = [{ value: '2025-01', label: '2025-01' }];

export type ApiVersion = (typeof MOCK_API_VERSIONS)[number]['value'];
